module.exports = __webpack_public_path__ + "img/norwegian@2x.81167de.png";